import { request } from "./client";
import {
  LeaderboardParams,
  LeaderboardResponse,
  LeaderboardItem,
} from "./types";

export const fetchLeagueLeaderboard = async (
  params: LeaderboardParams,
  nextPageToken?: string,
  requestedSize = 20,
  results: LeaderboardItem[] = [],
): Promise<{results: LeaderboardItem[]; next?: string}> => {
  const missing = requestedSize - results.length;

  const response = await fetchLeaderboardPage(params, nextPageToken, missing);

  const combinedResults = [...results, ...response.results];

  if (combinedResults.length >= requestedSize || (!response.next || response.results.length === 0)) {
    return { results: combinedResults.slice(0, requestedSize), next: response.next };
  }

  return fetchLeagueLeaderboard(
    params,
    response.next,
    requestedSize,
    combinedResults,
  );
};

export const fetchLeaderboardPage = async (
  params: LeaderboardParams,
  nextPageToken?: string,
  limit = 20,
): Promise<{ results: LeaderboardItem[]; next?: string }> => {
  const query = `query ($id: ID!, $limit: Int!, $type: PageLeaderboardType!, $after: String) {
    page(type: ONE_PAGE, id: $id) {
      leaderboard(first: $limit, type: $type, after: $after) {
        nodes {
          slug
          legacyId
          title
          status
          donationSummary {
            totalAmount {
              value
              currencyCode
            }
          }
        }
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }`
  const variables = { id: params.campaign, limit, type: "TEAMS", ...(nextPageToken ? { after: nextPageToken } : {}) };
  const response = await request<LeaderboardResponse>('/v1/justgiving/graphql', { method: 'POST', body: { query, variables } })

  const results: LeaderboardItem[] = response.data.page.leaderboard.nodes.map((item) => ({
    slug: item.slug,
    legacyId: item.legacyId,
    title: item.title,
    donationAmount: item.donationSummary?.totalAmount?.value,
    currencyCode: item.donationSummary?.totalAmount?.currencyCode,
    currencySymbol: "£",
    status: item.status
  }));

  return {
    results: filterLeaderboardResults(results),
    next: response.data.page.leaderboard.pageInfo.endCursor
  }
};

const filterLeaderboardResults = (
  results: LeaderboardItem[],
): LeaderboardItem[] => {
  return results.filter((item) => {
    return item.status !== "CANCELLED" && Number(item.donationAmount) !== 0
  });
};
